import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Tabs from './src/tabs'
import TabPane from './src/tab-pane.vue'

export const JdTabs = withInstall(Tabs, {
  TabPane,
})
export const JdTabPane = withNoopInstall(TabPane)
export default JdTabs

export * from './src/tabs'
export * from './src/tab-bar'
export * from './src/tab-nav'
export * from './src/tab-pane'
export * from './src/constants'
